import React, {Component} from 'react';
import {connect} from 'react-redux';
import {retrieveGroups} from '../actions/index'
import AdminPanel from '../components/admin/AdminPanel'
import {userIsAdmin} from '../constants'
import _ from 'lodash'

class AdminContainer extends Component {

    componentWillMount() {
        //console.log('GroupsContainer', this.props)
        if (!this.props.user) {return}
        if (this.props.routeParams.groupId) {

        } else {
            this.props.dispatch(retrieveGroups())
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.user && !prevProps.user && userIsAdmin(this.props.user)) {
            this.props.dispatch(retrieveGroups())
        }
    }

    render() {

        //console.log('AdminContainer render', this.props.groups, this.props.selectedGroupUsers)

        const groups = (this.props.groups || []).map(g => ({
            "group": g,
            "users": _.sortBy(_.values((this.props.selectedGroupUsers || {})).filter(user => (user || {}).group === g.id), u => (u.name || '').toLowerCase())
        }));

        return (<div>
                <h2>CHRISTCHURCH AIRPORT</h2>
                <h3>Engine Testing Management System</h3>

                <AdminPanel {...this.props} groups={groups} tests={this.props.reportTests} />
            </div>
        );
    }
}

export default AdminContainer = connect(state => {

    return {
        user: (state.data || {}).ETMSUser,
        groups: (state.data || {}).groups,
        groupUsers: (state.data || {}).groupUsers,
        selectedGroupUsers: (state.data || {}).selectedGroupUsers || {},
        allUsers: (state.data || {}).allUsers,
        loading: (state.data || {}).loading || {},
        reportTests: (state.data || {}).reportTests || [],
        report: (state.data || {}).report,
        MDAYearly: (state.data || {}).MDAYearly,
    }
})(AdminContainer);








// WEBPACK FOOTER //
// ./src/containers/AdminContainer.jsx